import { LOCALE_META, type Locale } from "./locales";
import { detectLocale } from "./runtime";
import { translate } from "./messages";

export type { Locale };
export type TranslationKey = string;

export { translate };

/** Locale for the current render (URL prefix on the server, URL/cookie on the client). */
export function useLocale(): Locale {
  return detectLocale();
}

export function useT() {
  const locale = useLocale();
  const t = (key: TranslationKey, vars?: Record<string, string | number>) =>
    translate(locale, key, vars);
  return { t, locale, dir: LOCALE_META[locale].dir, meta: LOCALE_META[locale] };
}
